import { find } from 'rambda'

import type { FlowEdge, FlowNode, Workflow } from '../../types'
import { ClassNode } from '../../types'
import type { FlowExecutorNode } from './type'

function setResult(nodeId: string, edges: FlowEdge[], nodes: FlowNode[], result: Map<string, FlowExecutorNode<FlowNode>>) {
    const node = nodes.find(item => item.id === nodeId)!

    result.set(nodeId, {
        id: nodeId,
        left: [...new Set(edges.filter(e => e.target === nodeId).map(item => item.source))],
        right: [...new Set(edges.filter(e => e.source === nodeId).map(item => item.target))],
        data: node
    })
}

// /** 构建工作流的链表结构 */
// export function buildWorkFlowDataDependencies(workflow: Workflow) {
//     const {
//         content: { edges, nodes }
//     } = workflow

//     const result = new Map<string, FlowExecutorNode<FlowNode>>()

//     for (const edge of edges) {
//         if (!result.has(edge.source)) {
//             const nodeId = edge.source
//             setResult(nodeId, edges, nodes, result)
//         }

//         if (!result.has(edge.target)) {
//             const nodeId = edge.target
//             setResult(nodeId, edges, nodes, result)
//         }
//     }

//     return result
// }

/** 构建工作流的链表结构 */
export function buildWorkFlowDataDependencies(workflow: Workflow) {
    const {
        content: { edges, nodes }
    } = workflow

    const result = new Map<string, FlowExecutorNode<FlowNode>>()

    // 1. 找到起始节点”
    const startNode = find(n => n.type === ClassNode.TRIGGER, nodes)
    if (!startNode) {
        return result
    }
    // 2. 从起始节点出发，BFS 获取所有可达节点
    const reachable = new Set<string>()
    const queue = [startNode.id]

    while (queue.length > 0) {
        const current = queue.shift()!
        if (reachable.has(current)) {
            continue
        }
        reachable.add(current)

        const nextNodes = edges.filter(e => e.source === current).map(e => e.target)
        queue.push(...nextNodes)
    }

    // 3. 只处理可达节点
    for (const nodeId of reachable) {
        setResult(nodeId, edges, nodes, result)
    }

    return result
}
